"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _router = _interopRequireDefault(require("@/router"));
var _redemptions = require("@/api/redemptions");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.open = false;
    this.listQuery = {
      page: 0,
      limit: 10,
      'employee.name': undefined,
      status: 'PENDING',
      filter: {
        'employee.name': '$contL',
        status: '$eq'
      }
    };
    this.showVerifyButton = true;
    this.showRejectButton = true;
    this.selectedProfiles = [];
    this.value = [];
    this.columns = {
      createdDate: false
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'ASC'
    }, {
      label: 'ID Descending',
      key: 'DESC'
    }];
  }
  created() {
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await (0, _redemptions.getRedemptions)((0, _index2.getQuery)(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 0;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleSelectionChange(selection) {
    this.selectedProfiles = selection;
    if (selection.length > 0) {
      this.showVerifyButton = false;
      this.showRejectButton = false;
    } else {
      this.showVerifyButton = true;
      this.showRejectButton = true;
    }
  }
  async verifyRedemption() {
    try {
      this.listLoading = true;
      const data = this.selectedProfiles.map(employee => employee.id);
      // console.log(data);
      await (0, _redemptions.approveRedemption)(data);
      this.$notify({
        title: 'Success',
        message: 'Redemption Verified successfully',
        type: 'success',
        duration: 2000
      });
      _router.default.push('/dashboard');
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
      throw error;
    }
  }
  async rejectRedemption() {
    try {
      this.listLoading = true;
      const data = this.selectedProfiles.map(employee => employee.id);
      // console.log(data);
      await (0, _redemptions.rejectRedemption)(data);
      this.$notify({
        title: 'Success',
        message: 'Redemption Rejected successfully',
        type: 'success',
        duration: 2000
      });
      _router.default.push('/dashboard');
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
      throw error;
    }
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'RedemptionsList',
  components: {
    Pagination: _index.default,
    Enabled: _index3.default
  }
})], default_1);
var _default = exports.default = default_1;